import React from 'react'

const DashboardPage = () => {
  return (
    <div>Dashboard Page</div>
  )
}

export default DashboardPage